/**
 * Typed ops gateway health API facade over the generated contract client.
 */

import { opsGatewayHealthApi } from '../api/generated/opsGatewayHealth.api.js';
import {
  type GatewayHealthListQuery,
  type GatewayHealthListResponse,
  type OpsPeripheralProbeResponse,
} from '@cnapse/shared/schemas.js';

class OpsGatewayHealthService {
  async getGatewayHealthList(query: GatewayHealthListQuery): Promise<GatewayHealthListResponse> {
    return opsGatewayHealthApi.list(query) as Promise<GatewayHealthListResponse>;
  }

  async probeEfemPeripherals(
    serialNumber: string,
    reason?: string,
  ): Promise<OpsPeripheralProbeResponse> {
    return opsGatewayHealthApi.probePeripherals(
      { serialNumber },
      reason ? { reason } : {},
    ) as Promise<OpsPeripheralProbeResponse>;
  }
}

export const opsGatewayHealthService = new OpsGatewayHealthService();
